module.exports = __webpack_public_path__ + "img-dashboard/register/close-white.8ebf4abe.png";